import i18next from "i18next";
import { withBreadCrumbs } from "lego-gui-lib";
import { inject } from "mobx-react";
import React from "react";
import { Route, RouteComponentProps, Switch, useHistory } from "react-router";
import { CreateView, IndexView, ShowView } from "lego-gui-lib/lib";
import { ParentRoute } from "../../core/model/parent";
import { ReportDefinitionColumns, ReportDefinitionSchema } from "./schema";
import { observer } from "mobx-react-lite";

export const ReportDefinitions = {
  url: "/reportDefinitions",
  handler: (props: RouteComponentProps<any>) => {
    const title = i18next.t("hns:reportDefinition:domain_plural");
    const baseUrl = props.match.url;

    return withBreadCrumbs(
      { to: baseUrl, children: title },
      <>
        <ParentRoute
          path={baseUrl + "/:id"}
          dataSourceName={"reportDefinition"}
        />
        <Switch>
          <Route exact={true} path={baseUrl} component={Index} />
          <Route path={baseUrl + "/create/:id"} component={Create} />
          <Route path={baseUrl + "/create"} component={Create} />
          <Route path={baseUrl + "/:id"} component={Show} />
        </Switch>
      </>
    );
  }
};

const injectDataSource = (comp: any) =>
  inject("reportDefinition", "auth", "language", "i18n")(observer(comp));

export const Index = injectDataSource(
  ({ reportDefinition, i18n, auth, ...rest }: any) => {
    const title = i18n.t("hns:reportDefinition:domain", { count: 2 });
    const allowed = auth.isAdmin();
    return (
      <IndexView
        dataSource={reportDefinition.listDataSource}
        {...rest}
        title={title}
        toolbarButtons={{ delete: true, export: true }}
        rowButtons={{
          edit: allowed,
          delete: allowed,
          copy: allowed,
          export: allowed
        }}
        columns={ReportDefinitionColumns}
      />
    );
  }
);

export const Create = injectDataSource(
  ({ reportDefinition, i18n, match, auth, ...rest }: any) => {
    const title = i18n.t("common:create", {
      domain: "hns:reportDefinition:domain"
    });
    const baseUrl = match.url;
    const history = useHistory();
    return withBreadCrumbs(
      { to: baseUrl + "/create", children: title },
      <CreateView
        dataSource={reportDefinition.oneDataSource}
        {...rest}
        title={title}
        initialValues={
          match.params.id
            ? undefined
            : {
                definition: {
                  callsTotal: false,
                  avgCallDuration: false,
                  totalCallDuration: false,
                  callsAnswered: false,
                  callsBusy: false,
                  callsRinging: false,
                  callsNoAnswer: false,
                  callsOtherReason: false,
                  queuedCallsTotal: false,
                  queuedCallsPercentage: false,
                  avgTimeInQueue: false
                }
              }
        }
        fields={ReportDefinitionSchema}
        id={match.params}
        goBack={() => history.goBack()}
      />
    );
  }
);

export const Show = injectDataSource((props: any) => {
  const { reportDefinition, language, match, auth, i18n, ...rest } = props;
  const title = i18n.t("common:edit", {
    domain: "hns:reportDefinition:domain"
  });
  const baseUrl = match.url;
  const notAllowed = !auth.isAdmin();
  const history = useHistory();

  return withBreadCrumbs(
    { to: baseUrl + "/edit", children: title },
    <ShowView
      dataSource={reportDefinition.oneDataSource}
      hideDeleteButton={notAllowed}
      title={title}
      fields={
        notAllowed
          ? ReportDefinitionSchema.makeAllReadonly()
          : ReportDefinitionSchema
      }
      id={match.params}
      preloadData={false}
      onlyView={notAllowed}
      goBack={() => history.goBack()}
    />
  );
});
